<template>
  <div>
    <div class="form-group">
      <div class="signature-pad type">
        <label for="fullName">
          {{ labels.fullName }}
        </label>
        <input
          id="fullName"
          ref="fullName"
          v-model="fullName"
          name="fullName"
          type="text"
        />
      </div>
    </div>
    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary btn-lg"
        :disabled="isDisabled"
      >
        {{ labels.agree }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    labels: {
      type: Object,
      required: true
    },
    canSign: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fullName: ''
    };
  },
  computed: {
    isEmpty() {
      return this.fullName.length === 0;
    },
    isDisabled() {
      return !this.canSign || this.isEmpty;
    }
  },
  mounted() {
    this.focus();
  },
  methods: {
    focus() {
      this.$refs.fullName.focus();
    }
  }
};
</script>
